import { render } from "./BaseTableAttributes.vue?vue&type=template&id=21185386&scoped=true"
import script from "./BaseTableAttributes.vue?vue&type=script&lang=js"
export * from "./BaseTableAttributes.vue?vue&type=script&lang=js"

import "./BaseTableAttributes.vue?vue&type=style&index=0&id=21185386&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21185386"]])

export default __exports__